<template>
    <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

        <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
            <filter-adviser/>
        </vs-sidebar>
        <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">

            <!-- Поиск -->
            <div class="flex border d-theme-dark-bg items-center" >
                <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleSidebar(true)"/>
            </div>

            <div class="px-2 py-2">
                <vs-button
                    @click="getExcelToken('students_list_with_credits_by_departments')"
                    id="students_list_with_credits_by_departments"
                    class="vs-con-loading__container ml-2"
                    size="small"
                > {{$t('students_list_with_credits_by_departments')}} </vs-button>
            </div>
            <div class="px-2 py-2">
                <vs-button
                    @click="getExcelToken('students_list_online_registration')"
                    id="students_list_online_registration"
                    class="vs-con-loading__container ml-2"
                    size="small"
                > {{$t('students_list_online_registration')}} </vs-button>
            </div>

            <div class="px-2 py-2">
                <vs-button
                    @click="getExcelToken('advisors_of_students')"
                    id="advisors_of_students"
                    class="vs-con-loading__container ml-2"
                    size="small"
                > {{$t('advisors_of_students')}} </vs-button>
            </div>
            <!-- список студентов -->
            <component
                :is="'VuePerfectScrollbar'"
                class="infinite_scroll_wrapper"
                ref="listScroll"
                :settings="settings"
                :key="$vs.rtl">
                <div class="mt-4 ml-5 mr-5" v-if="filter_none">
                    <vs-alert active="true">
                        {{ $t("select_filter") }}
                    </vs-alert>
                </div>
                <ul v-else>
                    <div v-if="GET_STUDENT_LIST.length == 0">
                        <vs-alert active="true" style="margin-top: 5px;">
                            {{ $t("no_data_text") }}
                        </vs-alert>
                    </div>
                    <div v-else>
                        <li
                            class="todo_todo-item cursor-pointer"
                            v-for="(item, index) in GET_STUDENT_LIST"
                            :key="`d_${index}`"
                            :style="[{transitionDelay: (index * 0.1) + 's'}]">
                            <ListItem ref="list_item_component" :item="item" @start_review_of_studycard="open_modal_start_review_of_studycard"/>
                        </li>
                    </div>
                </ul>
                <div id="infinite_loader" class="vs-con-loading__container"></div>
            </component>
        </div>
        <vs-popup :title="$t('start_review_of_studycard')" :active.sync="start_review_of_studycard">
            <p ref="popup_p_tag">  </p>
            <vs-button  @click="confirm_start_review_of_studycard" class="mt-2"> {{$t('start_review_of_studycard')}} </vs-button>
        </vs-popup>
    </div>
</template>

<script>
import FilterAdviser from './FilterAdviser'
import ListItem from './ListItem'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapActions, mapGetters } from "vuex";
import online_registration from "@/store/modules/online_registration";
export default {
    name: "Page",
    data() {
        return {
            clickNotClose: true,
            isSidebarActive: true,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            interval: false,

            intervalParams: {
                token: null,
                uid: null,
            },
            button_id: null,
            start_review_of_studycard:false

        }
    },
    components: {
        FilterAdviser,
        VuePerfectScrollbar,
        ListItem,
    },
    watch: {
        windowWidth () {
            this.setSidebarWidth()
        }
    },
    computed:{
        windowWidth() { return this.$store.state.windowWidth },
        ...mapGetters({
            GET_STUDENT_LIST:'online_registration/GET_STUDENT_LIST',
            GET_STATUS_INFO: 'online_registration/GET_STATUS_INFO',
            GET_CLICKED_STUDENT: 'online_registration/GET_CLICKED_STUDENT',
            GET_STATUS_RULES:'online_registration/GET_STATUS_RULES',
            GET_NOTIFY_DURATION: 'online_registration/GET_NOTIFY_DURATION'
        }),
        filter_none(){
            var route = this.$route.query
            if (route.study_year&&route.semester){
                return false
            }else{
                return true
            }
        },
        scrollbarTag () { return this.$store.getters.scrollbarTag }
    },
    methods:{
        ...mapActions({
            STATUS_INFO_START_REVIEW_OF_STUDYCARD:'online_registration/STATUS_INFO_START_REVIEW_OF_STUDYCARD',
        }),
        open_modal_start_review_of_studycard(item){
            this.start_review_of_studycard = true
            let popup_p_tag_text = this.$t('before_start_checking_studycard_of')
                + ' ' + item.profile.full_name + ' ' + this.$t('click_the_button_after_that_status_of_studycard_will_be_changed')
            this.$refs.popup_p_tag.innerText = popup_p_tag_text
            this.$store.commit('online_registration/SET_CLICKED_STUDENT', item)
        },
        async confirm_start_review_of_studycard(){
            let status_code
            if(this.GET_STATUS_RULES.before_send_to_advisor.includes(this.GET_CLICKED_STUDENT.status.code)){
                status_code = 'CHECKING'
            } else {status_code = 'CHECKING_AFTER'}

            let resp_data = await this.STATUS_INFO_START_REVIEW_OF_STUDYCARD({ status_code: status_code, student: this.GET_CLICKED_STUDENT, ...this.$route.query })

            if(resp_data.status_info.status.code !== status_code){
                this.open_modal_start_review_of_studycard(this.GET_CLICKED_STUDENT)
            }else {
                this.start_review_of_studycard = false
                this.$store.commit('online_registration/UPDATE_CLICKED_STUDENT_STATUS', status_code)
                this.$store.commit('online_registration/UPDATE_STUDENT_STATUS_IN_STUDENT_LIST', this.GET_CLICKED_STUDENT)
                this.$refs.list_item_component[0].go_online_registration(this.GET_CLICKED_STUDENT)
            }
        },

        go_online_registration(item){
            let queries = { student:item.profile.uid, ...this.$route.query };
            this.$router.push({ name:'online-registration-for-courses-adviser', query: queries });
        },
        toggleSidebar (value = false) {
            this.isSidebarActive = value
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false
            } else {
                this.isSidebarActive = this.clickNotClose = true
            }
        },
        get_name_from_doc_type(doc_type){
            switch (doc_type){
                case '6':
                    return this.$t('students_list_with_credits_by_departments')
                case '7':
                    return this.$t('advisors_of_students')
                case '8':
                    return this.$t('students_list_online_registration')
                default:
                    return this.$t("registration-results")
            }
        },
        set_doc_type_for_query(query, button_id){
            // class ExcelTask(BaseTask):
            // DOC_TYPE_CHOICES = (
            //     (1, 'Результат регистрации'),
            //         (2, 'Статистика регистрации '),
            //         (3, 'Список незарегистрированных'),
            //         (4, 'Заявки на ИУПЫ обуч'),
            //         (5, 'ИУПЫ обуч'),
            //         (6, 'Список студентов с кредитами по департаментам'),
            //         (7, 'Сводный отчет по Эдвайзерам студентов'),
            //         (8, 'Список студентов Online регистрации'),
            // )
            if (button_id === 'students_list_with_credits_by_departments' ){
                query.doc_type = '6'
                return query
            }
            if (button_id === 'advisors_of_students' ){
                query.doc_type = '7'
                return query
            }
            if (button_id === 'students_list_online_registration' ){
                query.doc_type = '8'
                return query
            }

        },
        async getExcelToken(button_id) {
            // button_id - тип отчета
            if (!this.$route.query.study_year||!this.$route.query.semester){
                this.$vs.notify({
                    time: this.GET_NOTIFY_DURATION,
                    title: this.$t("study_year_and_semester_must_be_chosen"),
                    color: "primary",
                });
                return
            }

            this.button_id = button_id
            try {
                this.$vs.loading({
                    container: `#${ this.button_id }` ,
                    scale: 0.45,
                });
                let query = this.$route.query;

                query = this.set_doc_type_for_query(query ,button_id)

                const res = await this.$http.get(`reports/excel/reg_result/adviser/online_registration_for_courses/`, {
                    params: query,
                });
                if (res.status === 200) {
                    this.intervalParams = res.data;
                    this.intervalParams.get = "status";

                    this.$vs.notify({
                        title: this.$t("file_process"),
                        time: 10000,
                        text: this.$t("some_time"),
                        color: "primary",
                        icon: "error",
                    });

                    // Временно. На период разработки отчета
                    // -------
                    // await this.sleep(5000);
                    // await this.getStatus();
                    // -------
                    // Временно закомменчено на период разработки отчета. Неудобно было дебажить. Постоянно прилетал запрос.
                    this.interval = setInterval(async () => {
                        await this.getStatus();
                    }, 2000);
                }
            } catch (e) {}
        },
        async getStatus() {
            let res
            try{
                res = await this.$http("/reports/get_file/", {
                    params: this.intervalParams,
                });
            }catch (e){
                if (e.error.message ==='requirements_for_graduating_or_students_and_teachers_load_type_is_empty'){
                    this.$vs.notify({
                        time: this.GET_NOTIFY_DURATION,
                        title: this.$t('requirements_for_graduating_or_students_and_teachers_load_type_is_empty'),
                        text: e.error.item.profile.full_name,
                        color: 'danger',
                    })
                }else {
                    this.$vs.notify({
                        time: this.GET_NOTIFY_DURATION,
                        text: this.$t('error'),
                        color: 'danger',
                    })
                }
            }
            if (res.data.done) {
                clearInterval(this.interval);
                await this.downloadFile();
            }
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async downloadFile() {
            await this.$http
                .get("reports/get_file/", {
                    responseType: "blob",
                    params: { token: this.intervalParams.token, get: "file" },
                })
                .then((response) => {
                    // Создаю тег а виртуальный
                    const link = document.createElement("a");
                    // Добавляю к нему ссылку на закачку
                    link.href = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    // Устанавливаю к нему атрибуты названия файла и метод
                    link.setAttribute(
                        "download",
                        this.get_name_from_doc_type(response.headers['report-type']) + ".xlsx"
                    );
                    // Вставляю/заменяю тег а в конце body
                    document.body.appendChild(link);
                    // Произвожу клик
                    link.click();
                });
            console.log(`#${ this.button_id } > .con-vs-loading`);
            this.$vs.loading.close( `#${ this.button_id } > .con-vs-loading`);
            this.button_id = null
        },
    },
    async created() {
        if(!this.$store.hasModule('online_registration'))
            this.$store.registerModule('online_registration', online_registration)
        this.setSidebarWidth()
    },

};
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.emc__actions{
    .con-vs-tabs{
        padding-bottom: 2px;
        width: auto;
    }
    .con-slot-tabs{
        display: none;
    }
}
.emc_list_tabs{
    .con-ul-tabs{
        display: none;
    }
    .vs-tabs--content{
        padding: 0px;
    }
}
.filters_scroll_area{
    position: relative;
    width: 100%;
    margin: auto;
    &.aside_scroll_teacher{
        height: calc(100% - 67px);
    }
    &:not(.aside_scroll_teacher){
        height: 100%;
    }
}
.infinite_scroll_wrapper{
    margin: auto;
    position: relative;
    width: 100%;
    height: calc(100% - 100px);
    .infinite_alert{
        padding-left: 15px;
        padding-right: 15px;
        margin-top: 10px;
        text-align: center;
    }
}
#infinite_loader{
    padding: 20px 0;
    .con-vs-loading{
        background: transparent;
    }
}
.full-vs-sidebar{
    .mail-sidebar-content{
        background-color: rgb(248, 248, 248) !important;
    }
    .email-header{
        box-shadow: 0 4px 6px rgba(0,0,0,.04);
        border-bottom: 1px solid #eee;
    }
}
</style>
